module.exports = __webpack_public_path__ + "img/1.5bfa8f68.png";